import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, ArrowLeft } from 'lucide-react';
import Button from '../components/ui/Button';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <Compass className="h-16 w-16 text-primary-600 mb-6" />
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 text-center">Page Not Found</h1>
      <p className="text-gray-600 mb-8 text-center max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/">
        <Button
          icon={<ArrowLeft className="h-4 w-4" />}
        >
          Return to Home
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;